<template>
  <div>
    <h2 class="title is-4 is-main-title">Equipa</h2>
    <h3 class="title is-size-5 is-main-title">INVESTIGADORES</h3>
    <div class="columns is-vcentered is-gapless">
      <div class="column is-2">
        <img src="@/assets/FC.png" class="is-researcher-picture">
      </div>
      <div class="column">
        <p><b>Fernanda Maria Guedes de Campos</b> (CHAM – Centro de Humanidades NOVA FCSH e UAç; CEHR - Centro de
          Estudos de História Religiosa UCP) – Coordenadora<br/>
          Doutorada em História (NOVA FCSH) e Pós-Graduada em Ciências Documentais (FLUL), foi Subdiretora
          da Biblioteca Nacional (1992-2006). Nesse período coordenou organizações nacionais e
          internacionais ligadas a bibliotecas, nos domínios da normalização bibliográfica, gestão e
          valorização de coleções patrimoniais, desenvolvimento e aplicação de novas tecnologias da
          Informação e Comunicação e cooperação internacional. Lecionou, nos cursos de Ciências
          Documentais, na FLUL e na UAL, bem como no Mestrado em Informação e Bibliotecas Digitais do
          ISCTE. Na atualidade, é investigadora integrada do Centro de Humanidades (CHAM-NOVA FCSH e
          UAç) fazendo parte do Grupo Leitura e Formas de Escrita e investigadora convidada do Centro
          de Estudos de História Religiosa (CEHR UCP). As suas áreas de interesse e investigação são a
          História do Livro, da Leitura e das Bibliotecas no Antigo Regime, com destaque para o
          século XVIII e a História das Ordens Religiosas em Portugal. Participa regularmente em
          encontros científicos e tem diversos artigos e livros publicados, sendo os últimos, <i>Para se
            achar facilmente o que se busca: bibliotecas, catálogos e leitores (séc. XVIII)</i>. Casal de
          Cambra, Caleidoscópio, 2015 e <i>A ordem das Ordens religiosas: roteiro identitário de Portugal
            (séculos XII-XVIII)</i>. Casal de Cambra: Caleidoscópio, 2017. </p>
      </div>
    </div>
    <div class="columns is-vcentered is-gapless">
      <div class="column is-2">
        <img src="@/assets/ACG.png" class="is-researcher-picture">
      </div>
      <div class="column">
        <p><b>António Camões Gouveia</b> (CHAM – Centro de Humanidades NOVA FCSH e UAç; CEHR - Centro de Estudos de
          História Religiosa UCP) – Investigador<br />
          Licenciado em História, pós-graduado em História Cultural e Política e doutorado em História
          e Teoria das Ideias, especialidade em História das Ideias Sociais, pela F.C.S.H. da U.N.L.
          Nessa mesma Faculdade dá aulas desde 1981. Enquanto docente tem lecionado matérias no âmbito
          da História da Sociedade e da Cultura (séculos XVI a XVIII) e da Programação de Cultura.
          Investigador do Centro de Humanidades (CHAM) da UNL-UAç e do Centro de Estudos de História
          Religiosa (CEHR) da UCP. Esteve em Comissão de Serviço entre 1992 e 1997 na Comissão
          Nacional para a Comemoração dos Descobrimentos Portugueses e de 2010 a 2012 como diretor do
          Museu de Évora. De 2004 a 2013 foi Coordenador Científico da Fundação Robinson, em
          Portalegre. As suas áreas de interesse científico centram-se na História Social, das
          Sociabilidades e dos Poderes nas vertentes da História da Cultura, das Mentalidades e da
          História Religiosa. Em confluência teórico-prática junta-lhes a Programação de Cultura, nas
          dimensões do Património, da Museologia e da Mediação.</p>
      </div>
    </div>
    <div class="columns is-vcentered is-gapless">
      <div class="column is-2">
        <img src="@/assets/DRA.png" class="is-researcher-picture">
      </div>
      <div class="column">
        <p><b>Daniel Alves</b> (IHC - Instituto de História Contemporânea NOVA FCSH) – Investigador<br/>
          Professor Auxiliar no Departamento de História da Faculdade de Ciências Sociais e Humanas e
          investigador no Instituto de História Contemporânea, ambos da Universidade NOVA de Lisboa.
          Tem um mestrado em História do Século XIX (2001) e um doutoramento em História Económica e
          Social Contemporânea (2010) com a tese <i>A República atrás do balcão: os lojistas de Lisboa
            e o fim da Monarquia (1870-1910)</i>. As suas áreas de interesse são a História
          Contemporânea, a História Económica e Social, a História Urbana, a História das Revoluções
          e as Humanidades Digitais. Tem alguns livros e capítulos de livros publicados sobre História
          de Portugal no século XIX, bem como artigos em revistas científicas nacionais e internacionais,
          sobretudo em História Económica e Social e SIG aplicado à História. Recentemente foi editor
          convidado no número especial “Digital Methods and Tools for Historical Research” da revista
          <i>International Journal of Humanities and Arts Computing</i> e do número especial “The
          History of Retailing on the Iberian Peninsula” da revista <i>History of Retailing and
            Consumption</i>. Colabora com frequência em projectos de investigação que usam bases de
          dados e sistemas de informação geográfica (SIG) na investigação histórica. Recentemente
          colaborou nos projectos “<a href="http://atlas.fcsh.unl.pt/" target="_blank">Atlas, Cartografia
            Histórica</a>” e “<a href="http://litescape.ielt.fcsh.unl.pt/" target="_blank">Atlas das
            Paisagens Literárias de Portugal Continental</a>”. É coordenador deste último desde 2018.
            Está actualmente a desenvolver estudos sobre a História de Lisboa e a evolução do seu
            comércio de retalho no final do século XIX e princípios do século XX. </p>
      </div>
    </div>

    <div class="columns is-vcentered is-gapless">
      <div class="column is-2">
        <img src="@/assets/DG.png" class="is-researcher-picture">
      </div>
      <div class="column">
        <p><b>Daniel Giebels</b> (CHSC – Centro de História da Sociedade e da Cultura, FLUC; CEHR – Centro de Estudos
          de História Religiosa, UCP).<br />
          Doutorado em Altos Estudos em História, ramo época moderna (FLUC), com a tese <i>A Inquisição de Lisboa – O
            epicentro da dinâmica inquisitorial (1537-1579)</i> (2016), projeto realizado com recurso a uma bolsa
          da FCT e publicado em 2018 pela Gradiva; Mestre em História Moderna (FLUC) com a dissertação <i>A relação
            entre a Inquisição e D. Miguel de Castro, arcebispo de Lisboa (1586-1625)</i>; e licenciado em Património
          Cultural (UALG) com o trabalho <i>Magia e sociedade no Algarve da 4ª década do século XVII</i>. Participou nos
          projetos <i>Cliorhes.net</i>, pela FLUC, <i>Portugaliae Monumenta Misericordiarum</i>, pelo CEHR, tendo
          ainda realizado estudos histórico-artísticos para a DGEMN e para a Delegação Regional de Cultura do Algarve,
          encontrando-se atualmente como investigador no projeto internacional <i>ReligionAJE - Religião, administração
            e justiça eclesiástica no Império Português (1514-1750)</i>, onde se dedica ao estudo da atuação da
          Igreja no Norte de África. Autor de vários artigos e comunicações em revistas e eventos, nacionais e
          internacionais, sobre a Inquisição e a Igreja em Portugal e no seu Império entre os séculos XVI e XVIII.
          Co-vencedor do 1º Prémio Nacional de Ensaio Histórico António Rosa Mendes, com o trabalho <i>D. João de Melo
            e Castro (? – 1574) Estudo prosopográfico e reconstituição das dinâmicas de poder em Portugal de meados
            do século XVI</i> (2015).</p>
      </div>
    </div>

    <div class="columns is-vcentered is-gapless">
      <div class="column is-2">
        <img src="@/assets/ICP.png" class="is-researcher-picture">
      </div>
      <div class="column">
        <p><b>Isabel Castro Pina</b> (CEHR - Centro de Estudos de História Religiosa UCP; IEM – Instituto de Estudos
          Medievais NOVA FCSH) – Investigadora<br />
          Doutorada em História, especialidade História Medieval, pela Faculdade de Ciências Sociais e
          Humanas da Universidade Nova de Lisboa (2011), com a dissertação <i>Os Lóios em Portugal: Origens
            e primórdios da Congregação dos Cónegos Seculares de São João Evangelista</i>. Participação
          no projeto de investigação sobre ordens religiosas em Portugal (história e património) da
          responsabilidade do Centro de Estudos de História Religiosa da Universidade Católica Portuguesa,
          financiado pela Fundação Ciência e Tecnologia e Fundação Calouste Gulbenkian, cujos resultados
          foram publicados em <i>Ordens religiosas em Portugal: Das origens a Trento. Guia histórico</i>,
          por Bernardo Vasconcelos e Sousa (dir.), Isabel Castro Pina, Maria Filomena Andrade e Maria
          Leonor F.O. Silva Santos, Lisboa, Livros Horizonte, 3ª edição, 2016. Colaboração no projeto
          CLAUSTRA (2014) da responsabilidade do Institut de Recerca en Cultures Medievals da Universidade
          de Barcelona: plataforma ativa destinada à comunidade científica e acessível através da
          internet que cataloga e cartografa espaços de espiritualidade feminina medievais nos reinos
          peninsulares, (cfr. <a href="http://www.ub.edu/claustra/spa/info" target="_blank">http://www.ub.edu/claustra/spa/info</a>). Membro integrado do Centro de Estudos de História Religiosa da Universidade
          Católica Portuguesa e colaborador do Instituto de Estudos Medievais da Faculdade de Ciências Sociais
          e Humanas da Universidade Nova de Lisboa. Áreas de investigação privilegiadas: Fontes e Arquivística
          Religiosa. História institucional, cultural e religiosa. Ordens religiosas na Idade Média.</p>
      </div>
    </div>

    <div class="columns is-vcentered is-gapless">
      <div class="column is-2">
        <img src="@/assets/JLF.png" class="is-researcher-picture">
      </div>
      <div class="column">
        <p><b>João Luís Fontes</b> (IEM – Instituto de Estudos Medievais NOVA FCSH; CEHR - Centro de Estudos de
          História Religiosa UCP) – Investigador<br />
          Professor contratado em História Medieval pela Faculdade de Ciências Sociais e Humanas da
          Universidade Nova de Lisboa. É Doutor em História Medieval (2012) pela mesma Faculdade, com
          uma dissertação intitulada <i>Da Pobre Vida à Congregação da Serra de Ossa. Génese e
            institucionalização de uma experiência eremítica (1366-1510)</i>>. Foi ainda Bolseiro de
          Pós-Doutoramento pela Fundação para a Ciência e Tecnologia, entre 2013 e 2019, com o projeto
          “O deserto na cidade: experiências religiosas femininas em Portugal nos finais da Idade
          Média (1350-1525)”. É membro do Instituto de Estudos Medievais da mesma Faculdade, do qual é
          atualmente Subdiretor, e do Centro de Estudos de História Religiosa da Universidade Católica
          Portuguesa. Participa atualmente nos projetos “Paisajes espirituales. Modelos de aproximación
          espacial a las transformaciones de la religiosidad femenina medieval en los Reinos Peninsulares
          (ss .XII-XVI)” (HAR2014-52198-P), coordenado pela Prof. Blanca Gari de Aguilera, e “Les mots de
          l’impôt dans l’Occident méditerrannéen: glossaire de fiscalité médiévale”, coordenado por
          Denis Menjot. Atuais interesses de investigação: Eremitismo, Espiritualidade Laical, Literatura
          Hagiográfica, Cultura e Piedade Cortesãs e Nobiliárquicas, Elites Sociais, Geografia e Património
          das Instituições Religiosas, Rituais e Culto Litúrgico, História da Espiritualidade, História
          das Mulheres.</p>
      </div>
    </div>

    <div class="columns is-vcentered is-gapless">
      <div class="column is-2">
        <img src="@/assets/JC.png" class="is-researcher-picture">
      </div>
      <div class="column">
        <p><b>Jorge Resende Campos</b><br />
          Licenciado em História de Arte (NOVA FCSH, 2019), mestrando em História de Arte (NOVA FCSH). Frequentou
          vários cursos de curta duração nas áreas da História de Arte, Património e Museologia em instituições de
          ensino superior como a École du Louvre, Paris, e a FCSH – Universidade Nova de Lisboa. Estágio na Câmara
          Municipal de Lisboa, na Divisão de Planeamento Territorial do Departamento de Planeamento Urbano – realização
          de fichas de inventário e outros trabalhos na área da história da arquitetura e do urbanismo.
        </p>
      </div>
    </div>

    <div class="columns is-vcentered is-gapless">
      <div class="column is-2">
        <img src="@/assets/MFA.png" class="is-researcher-picture">
      </div>
      <div class="column">
        <p><b>Maria Filomena Andrade</b> (UAb; CEHR - Centro de Estudos de História Religiosa UCP; IEM – Instituto de
          Estudos Medievais NOVA FCSH) – Investigadora<br />
          Licenciada em História pela Faculdade de Letras da Universidade de Lisboa, é Mestre e Doutora
          em História Medieval pela Faculdade de Ciências Sociais e Humanas da Universidade Nova de
          Lisboa. É docente na Universidade Aberta, e investigadora no Centro de Estudos de História
          Religiosa (CEHR) e no Instituto de Estudos Medievais (IEM). Autora de diversas publicações,
          destacam-se, entre elas: <i>Isabel de Aragão. Rainha Santa e Mãe exemplar</i>, Círculo de Leitores,
          2012; <i>Inventário dos fundos monástico-conventuais da Biblioteca Pública de Évora</i> (coautoria com
          João Luís Inglês Fontes e Joaquim Bastos Serra, apresentação José Mattoso), CIDEHUS, 2010; <i>Ordens
            Religiosas em Portugal. Das Origens a Trento – Guia Histórico</i>, (coautoria com Bernardo
          Vasconcelos e Sousa, Isabel Castro Pina e Maria Leonor Ferraz de Oliveira Silva Santos), Livros
          Horizonte, 2005; <i>O Mosteiro de Chelas: uma comunidade feminina na Baixa Idade Média.
            Património e gestão</i>, Cascais, Patrimonia, 1996. As suas áreas de interesse e especialização
          são a História Religiosa; o Monaquismo Feminino; a Arquivística Religiosa; e os Estudos das
          Mulheres. </p>
      </div>
    </div>

    <div class="columns is-vcentered is-gapless">
      <div class="column is-2">
        <img src="@/assets/PAA.png" class="is-researcher-picture">
      </div>
      <div class="column">
        <p><b>Paulo Alexandre Alves</b> (IHC - Instituto de História Contemporânea NOVA FCSH; CEHR – Centro de Estudos
          de História Religiosa, UCP)<br />
          Mestre em História Contemporânea pela Universidade Nova de Lisboa, é também Mestre em Teologia pela
          Universidade Católica Portuguesa e Mestre em Engenharia Informática pelo Instituto Superior Técnico,
          da Universidade de Lisboa. Actualmente é doutorando em História Contemporânea na Universidade Nova de
          Lisboa com um projeto de investigação prosopográfico sobre o episcopado português na Monarquia Constitucional,
          tendo obtido para esse efeito uma bolsa da Fundação para a Ciência e Tecnologia. Os seus interesses de
          investigação prendem-se com a história social e religiosa contemporânea e com as Humanidades Digitais.
          Tem participado em vários projetos na área da história que utilizam plataformas informáticas,
          especialmente aquelas focadas na Web. É investigador integrado do Instituto de História Contemporânea e
          membro do Centro de Estudos de História Religiosa.</p>
      </div>
    </div>

    <div class="columns is-vcentered is-gapless">
      <div class="column is-2">
        <img src="@/assets/RV.png" class="is-researcher-picture">
      </div>
      <div class="column">
        <p><b>Rolando Volzone</b> (DINÂMIA’CET-IUL) – Investigador<br />
          Mestre em Arquitetura pela Sapienza Università di Roma (2013), é doutor em Arquitetura dos Territórios
          Metropolitanos Contemporâneos pelo ISCTE-Instituto Universitário de Lisboa (2020), e investigador do Centro
          de Estudos sobre a Mudança Socioeconómica e o Território (DINÂMIA’CET-IUL). A sua tese de doutoramento,
          financiada pela FCT, é intitulada “Architectures of the Soul. Legacy of the Eremitical Congregation of
          São Paulo da Serra de Ossa (Portugal)”. Os primeiros resultados têm sido apresentados e publicados em
          Portugal, Itália, Áustria e Chipre. É coordenador dos seminários internacionais “Architectures of the
          Soul” (2017, 2018, 2020) e da conferência internacional e escola de verão “Digital Survey in Religious
          Architecture” (2018). Privilegia uma abordagem multidisciplinar em torno das vivências monástico-conventuais
          na área do Mediterrâneo, cruzando diversas perspetivas: a História, a Arquitetura, a Arquitetura Paisagista,
          o Desenho, o Património Cultural.</p>
      </div>
    </div>

    <h3 class="title is-size-5 is-main-title">CONSULTORES</h3>
    <div class="columns is-vcentered is-gapless">
      <div class="column is-2">
        <img src="@/assets/AMF.png" class="is-researcher-picture">
      </div>
      <div class="column">
        <p><b>António Matos Ferreira</b> (CEHR-Centro de Estudos de História Religiosa UCP; FLUL)<br />
          Doutorado em História Contemporânea pela Faculdade de Letras da Universidade de Lisboa e professor de
          história nesta mesma Faculdade e na Faculdade de Teologia da Universidade Católica Portuguesa. É membro do
          Centro de Estudos de História Religiosa, que dirigiu entre 2011 e início de 2014. É autor de diversos trabalhos
          científicos na área da História Religiosa e do Cristianismo moderno e contemporâneo, com destaque para as
          problemáticas do movimento católico, da secularização e da laicidade. A sua tese de doutoramento está
          publicada pelo Centro de Estudos de História Religiosa com o título <i>Um católico militante diante da
            crise nacional: Manuel Isaías Abúndio da Silva (1874-1914)</i>. Coordenou o projeto “Os católicos
          portugueses na política do século XX - a reflexão e intervenção de duas gerações: António Lino Neto e
          Francisco Lino Neto”, realizado entre 2007 e 2010, com financiamento da FCT.</p>
      </div>
    </div>
    <div class="columns is-vcentered is-gapless">
      <div class="column is-2">
        <img src="@/assets/CMA.png" class="is-researcher-picture">
      </div>
      <div class="column">
        <p><b>Carlos A. Moreira Azevedo</b> (CEHR-Centro de Estudos de História Religiosa; Conselho Pontifício
          para a Cultura)<br />
          Doutorou-se, em 1986, na Faculdade de História Eclesiástica da Universidade Gregoriana - Roma, com tese
          sobre iconografia. Foi Presidente da direção do Centro de Estudos de História Religiosa (1992-2001).
          Dirigiu a obra <i>Dicionário e História religiosa de Portugal</i>, em 7 volumes. Organizou várias
          exposições de arte religiosa. É Professor da Faculdade de Teologia da Universidade Católica Portuguesa
          desde 1987. Foi Vice-Reitor da Universidade Católica Portuguesa, desde outubro de 2000 a outubro de
          2004. É Membro da Academia Portuguesa da História, desde 1998. Foi Presidente da Fundação Spes (2006-2013).
          É Delegado do Conselho Pontifício da Cultura (11-11-2011- ), coordenando o Departamento dos bens
          culturais. É Membro da Comissão Pontifícia de Arqueologia sacra (2015- ). Tem mais de uma centena de
          trabalhos publicados, em livros e revistas. <i>Conventos e mosteiros de Portugal (1096-1910): espacialidades
            e temporalidades</i>.</p>
      </div>
    </div>
    <div class="columns is-vcentered is-gapless">
      <div class="column is-2">
        <img src="@/assets/FT.png" class="is-researcher-picture">
      </div>
      <div class="column">
        <p><b>Francisco Teixeira</b> (Ualg)<br />
          Doutorado em História da Arte Medieval incidindo a sua investigação em particular sobre a Arte Gótica.
          Professor da Universidade do Algarve. Tem participado em encontros de História da Arte, nacionais e
          internacionais, nos quais apresentou comunicações especialmente sobre Arquitetura, nomeadamente a
          arquitetura monástica e conventual, Escultura funerária, e análise de imagens medievais. Neste último
          campo de investigação tem trabalhado sobre a problemática das imagens dos claustros e a difusão de
          imagens na escultura arquitetónica, bem como as questões associadas aos aspetos da Arte e do Género.</p>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'Team',
}
</script>

<style scoped>
.is-main-title{
  margin: 0.55em;
}

.is-main-content p{
  font-size: 14px;
  text-align: justify;
  margin: 1em;
  line-height: 1.4;
}

.is-researcher-picture{
  margin-left: 20px;
}
</style>

